import { AppSelectBox } from 'components';
import useChapterTopics from 'hooks/API/GET/useChapterTopics';
import { Fragment } from 'react';

function ChapterTopicsDropDown({
  enableAPI,
  value,
  handleChange,
  dependencies = {},
  fieldErrors = {},
}) {
  const { query = '', classID, subjectID, chapterID } = dependencies;
  const queryParams = `?mode=dropdown${query ? `&${query}` : ``}`;

  const { data, isLoading, isError } = useChapterTopics({
    enabled: enableAPI,
    queryParams,
    classID,
    subjectID,
    chapterID,
  });

  return (
    <AppSelectBox
      labelProps={{ label: 'Select topics' }}
      selectProps={{
        value,
        onChange: handleChange,
      }}
      fieldErrors={fieldErrors}
    >
      {isLoading ? (
        <option disabled value="">
          Loading...
        </option>
      ) : isError ? (
        <option disabled value="">
          Failed to load list
        </option>
      ) : (
        <Fragment>
          {data?.data?.length > 0 ? (
            <Fragment>
              <option value="">Choose</option>
              {data?.data?.map((option) => {
                return (
                  <option key={option._id} value={option._id}>
                    {option.name}
                  </option>
                );
              })}
            </Fragment>
          ) : (
            <option value="">No options found</option>
          )}
        </Fragment>
      )}
    </AppSelectBox>
  );
}

ChapterTopicsDropDown.defaultProps = {
  handleChange: () => {},
};

export default ChapterTopicsDropDown;
